// src/components/common/FeedbackModal.jsx
import React, { Fragment } from "react";
import { Dialog, Transition, TransitionChild } from "@headlessui/react";

const FeedbackModal = ({
  isOpen,
  onClose,
  title,
  message,
  type = "info",
  closeButtonText = "OK",
}) => {
  let titleClasses = "text-lg font-medium leading-6 text-gray-900";
  if (type === "success") {
    titleClasses = "text-lg font-medium leading-6 text-green-600";
  } else if (type === "error") {
    titleClasses = "text-lg font-medium leading-6 text-red-600";
  } else if (type === "warning") {
    titleClasses = "text-lg font-medium leading-6 text-yellow-600";
  }

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} className="relative z-50">
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        </TransitionChild>

        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 transform-[scale(95%)]"
            enterTo="opacity-100 transform-[scale(100%)]"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 transform-[scale(100%)]"
            leaveTo="opacity-0 transform-[scale(95%)]"
          >
            <div className="w-full max-w-md overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl">
              {title && <h3 className={titleClasses}>{title}</h3>}

              {message && (
                <div className="mt-3">
                  <p className="text-sm text-gray-600 whitespace-pre-line">
                    {message}
                  </p>
                </div>
              )}

              <div className="mt-5 sm:mt-6">
                <button
                  type="button"
                  className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 sm:text-sm transition-colors"
                  onClick={onClose}
                >
                  {closeButtonText}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default FeedbackModal;
